export default function Menu() {
  const menuItems = [
    {
      id: 1,
      name: 'Kibbeh',
      description: 'Traditional Lebanese crispy bulgur shells filled with spiced ground meat and pine nuts',
      image: 'https://public.readdy.ai/ai/img_res/ad8d7627bc7161d462bc3b92536dcffe.jpg',
      category: 'Appetizers'
    },
    {
      id: 2,
      name: 'Lamb Shawarma',
      description: 'Slow-roasted marinated lamb with tahini, pickles, and fresh herbs',
      image: 'https://readdy.ai/api/search-image?query=authentic%20lamb%20shawarma%20slow%20roasted%20marinated%20lamb%20meat%20sliced%20thin%20with%20tahini%20sauce%20pickled%20vegetables%20fresh%20herbs%20parsley%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20main%20course&width=400&height=300&seq=lambshawarma002&orientation=landscape',
      category: 'Main Courses'
    },
    {
      id: 3,
      name: 'Chicken Shish Taouk',
      description: 'Grilled marinated chicken skewers with garlic sauce and grilled vegetables',
      image: 'https://readdy.ai/api/search-image?query=authentic%20chicken%20shish%20taouk%20grilled%20marinated%20chicken%20breast%20cubes%20on%20skewers%20with%20white%20garlic%20sauce%20toum%20grilled%20vegetables%20peppers%20onions%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20lebanese%20main%20course&width=400&height=300&seq=chickentaouk002&orientation=landscape',
      category: 'Main Courses'
    },
    {
      id: 4,
      name: 'Mixed Grill',
      description: 'Selection of lamb kofta, chicken, and beef skewers with rice and salad',
      image: 'https://readdy.ai/api/search-image?query=authentic%20mixed%20grill%20platter%20lamb%20kofta%20skewers%20chicken%20shish%20taouk%20beef%20kebab%20skewers%20with%20rice%20pilaf%20salad%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20main%20course&width=400&height=300&seq=mixedgrill002&orientation=landscape',
      category: 'Main Courses'
    },
    {
      id: 5,
      name: 'Lamb Kofta',
      description: 'Spiced minced lamb skewers with parsley, onions, and Mediterranean spices',
      image: 'https://readdy.ai/api/search-image?query=authentic%20lamb%20kofta%20spiced%20minced%20ground%20lamb%20meat%20skewers%20grilled%20with%20parsley%20onions%20mediterranean%20spices%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20main%20course&width=400&height=300&seq=lambkofta002&orientation=landscape',
      category: 'Main Courses'
    },
    {
      id: 6,
      name: 'Beef Kebab',
      description: 'Tender marinated beef cubes grilled to perfection with peppers and onions',
      image: 'https://readdy.ai/api/search-image?query=authentic%20beef%20kebab%20tender%20marinated%20beef%20cubes%20chunks%20grilled%20on%20skewers%20with%20bell%20peppers%20onions%20charred%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20main%20course&width=400&height=300&seq=beefkebab002&orientation=landscape',
      category: 'Main Courses'
    },
    {
      id: 7,
      name: 'Chicken Musakhan',
      description: 'Roasted chicken with sumac, caramelized onions, and toasted pine nuts',
      image: 'https://readdy.ai/api/search-image?query=authentic%20chicken%20musakhan%20roasted%20chicken%20pieces%20with%20sumac%20spice%20caramelized%20onions%20toasted%20pine%20nuts%20on%20taboon%20bread%20flatbread%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20palestinian%20main%20course&width=400&height=300&seq=chickenmusakhan002&orientation=landscape',
      category: 'Main Courses'
    },
    {
      id: 8,
      name: 'Lamb Ouzi',
      description: 'Slow-cooked lamb shoulder with fragrant rice, nuts, and raisins',
      image: 'https://readdy.ai/api/search-image?query=authentic%20lamb%20ouzi%20slow%20cooked%20tender%20lamb%20shoulder%20meat%20with%20fragrant%20spiced%20rice%20pilaf%20mixed%20nuts%20almonds%20pine%20nuts%20raisins%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20main%20course&width=400&height=300&seq=lambouzi002&orientation=landscape',
      category: 'Main Courses'
    },
    {
      id: 9,
      name: 'Kosher Lamb Tagine',
      description: 'Moroccan-style braised lamb with apricots, almonds, and aromatic spices',
      image: 'https://readdy.ai/api/search-image?query=authentic%20moroccan%20lamb%20tagine%20braised%20lamb%20meat%20with%20dried%20apricots%20almonds%20aromatic%20spices%20cinnamon%20in%20traditional%20tagine%20pot%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20moroccan%20main%20course&width=400&height=300&seq=lambtagine002&orientation=landscape',
      category: 'Main Courses'
    },
    {
      id: 10,
      name: 'Grilled Sea Bass',
      description: 'Whole sea bass marinated with lemon, garlic, and Mediterranean herbs',
      image: 'https://readdy.ai/api/search-image?query=authentic%20grilled%20whole%20sea%20bass%20fish%20marinated%20with%20lemon%20slices%20garlic%20mediterranean%20herbs%20parsley%20charred%20grill%20marks%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20seafood%20main%20course&width=400&height=300&seq=seabass002&orientation=landscape',
      category: 'Seafood'
    },
    {
      id: 11,
      name: 'Samak Harra',
      description: 'Spicy baked fish with tahini sauce, walnuts, and cilantro',
      image: 'https://readdy.ai/api/search-image?query=authentic%20samak%20harra%20spicy%20baked%20white%20fish%20fillet%20with%20tahini%20sauce%20crushed%20walnuts%20fresh%20cilantro%20coriander%20spicy%20red%20pepper%20sauce%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20lebanese%20seafood&width=400&height=300&seq=samakharra002&orientation=landscape',
      category: 'Seafood'
    },
    {
      id: 12,
      name: 'Grilled Prawns',
      description: 'Jumbo prawns with garlic butter, lemon, and fresh parsley',
      image: 'https://readdy.ai/api/search-image?query=authentic%20grilled%20jumbo%20prawns%20shrimp%20with%20garlic%20butter%20sauce%20lemon%20wedges%20fresh%20parsley%20garnish%20charred%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20seafood%20elegant%20presentation&width=400&height=300&seq=prawns002&orientation=landscape',
      category: 'Seafood'
    },
    {
      id: 13,
      name: 'Salmon Fillet',
      description: 'Pan-seared salmon with pomegranate glaze and roasted vegetables',
      image: 'https://readdy.ai/api/search-image?query=authentic%20pan%20seared%20salmon%20fillet%20with%20pomegranate%20molasses%20glaze%20roasted%20vegetables%20carrots%20zucchini%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20seafood%20elegant%20presentation&width=400&height=300&seq=salmon002&orientation=landscape',
      category: 'Seafood'
    },
    {
      id: 14,
      name: 'Seafood Sayadieh',
      description: 'Traditional fish and rice dish with caramelized onions and pine nuts',
      image: 'https://readdy.ai/api/search-image?query=authentic%20seafood%20sayadieh%20traditional%20lebanese%20fish%20rice%20dish%20with%20caramelized%20onions%20toasted%20pine%20nuts%20spiced%20yellow%20rice%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20lebanese%20seafood&width=400&height=300&seq=sayadieh002&orientation=landscape',
      category: 'Seafood'
    },
    {
      id: 15,
      name: 'Grilled Octopus',
      description: 'Tender octopus with lemon, olive oil, and Mediterranean herbs',
      image: 'https://readdy.ai/api/search-image?query=authentic%20grilled%20octopus%20tentacles%20tender%20charred%20with%20lemon%20wedges%20olive%20oil%20mediterranean%20herbs%20parsley%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20seafood%20elegant%20presentation&width=400&height=300&seq=octopus002&orientation=landscape',
      category: 'Seafood'
    },
    {
      id: 16,
      name: 'Moussaka',
      description: 'Layered eggplant, tomatoes, and chickpeas with aromatic spices',
      image: 'https://readdy.ai/api/search-image?query=authentic%20vegetarian%20moussaka%20layered%20eggplant%20slices%20tomato%20sauce%20chickpeas%20aromatic%20spices%20baked%20casserole%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20mediterranean%20vegetarian&width=400&height=300&seq=moussaka002&orientation=landscape',
      category: 'Vegetarian'
    },
    {
      id: 17,
      name: 'Stuffed Vine Leaves',
      description: 'Grape leaves filled with rice, herbs, tomatoes, and lemon',
      image: 'https://readdy.ai/api/search-image?query=authentic%20stuffed%20grape%20vine%20leaves%20dolma%20rolled%20with%20rice%20herbs%20tomatoes%20lemon%20wedges%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20vegetarian&width=400&height=300&seq=vineleaves002&orientation=landscape',
      category: 'Vegetarian'
    },
    {
      id: 18,
      name: 'Batata Harra',
      description: 'Spicy Lebanese potatoes with garlic, coriander, and chili',
      image: 'https://readdy.ai/api/search-image?query=authentic%20batata%20harra%20spicy%20lebanese%20fried%20potato%20cubes%20with%20garlic%20fresh%20coriander%20cilantro%20red%20chili%20peppers%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20lebanese%20vegetarian&width=400&height=300&seq=batataharra002&orientation=landscape',
      category: 'Vegetarian'
    },
    {
      id: 19,
      name: 'Loubieh Bil Zeit',
      description: 'Green beans cooked in olive oil with tomatoes, garlic, and onions',
      image: 'https://readdy.ai/api/search-image?query=authentic%20loubieh%20bil%20zeit%20green%20beans%20cooked%20in%20olive%20oil%20with%20tomato%20sauce%20garlic%20onions%20lebanese%20stew%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20lebanese%20vegetarian&width=400&height=300&seq=loubieh002&orientation=landscape',
      category: 'Vegetarian'
    },
    {
      id: 20,
      name: 'Fattet Hummus',
      description: 'Layered chickpeas, crispy pita, yogurt, and toasted pine nuts',
      image: 'https://readdy.ai/api/search-image?query=authentic%20fattet%20hummus%20layered%20chickpeas%20crispy%20toasted%20pita%20bread%20pieces%20yogurt%20sauce%20toasted%20pine%20nuts%20paprika%20in%20white%20bowl%20simple%20clean%20white%20background%20professional%20food%20photography%20lebanese%20vegetarian&width=400&height=300&seq=fattethummus002&orientation=landscape',
      category: 'Vegetarian'
    },
    {
      id: 21,
      name: 'Mujadara',
      description: 'Lentils and rice with caramelized onions and cumin',
      image: 'https://readdy.ai/api/search-image?query=authentic%20mujadara%20lentils%20rice%20pilaf%20with%20caramelized%20crispy%20onions%20cumin%20spice%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20vegetarian&width=400&height=300&seq=mujadara002&orientation=landscape',
      category: 'Vegetarian'
    },
    {
      id: 22,
      name: 'Spinach Fatayer',
      description: 'Baked pastries filled with spinach, onions, lemon, and sumac',
      image: 'https://readdy.ai/api/search-image?query=authentic%20spinach%20fatayer%20triangular%20baked%20pastries%20filled%20with%20spinach%20onions%20lemon%20sumac%20golden%20brown%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20lebanese%20vegetarian&width=400&height=300&seq=fatayer002&orientation=landscape',
      category: 'Vegetarian'
    },
    {
      id: 23,
      name: 'Grilled Halloumi',
      description: 'Cypriot cheese grilled with za\'atar and drizzled with honey',
      image: 'https://readdy.ai/api/search-image?query=authentic%20grilled%20halloumi%20cheese%20slices%20with%20zaatar%20spice%20honey%20drizzle%20charred%20grill%20marks%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20mediterranean%20vegetarian&width=400&height=300&seq=halloumi002&orientation=landscape',
      category: 'Vegetarian'
    },
    {
      id: 24,
      name: 'Baklava',
      description: 'Layers of filo pastry with pistachios, walnuts, and honey syrup',
      image: 'https://readdy.ai/api/search-image?query=authentic%20baklava%20traditional%20middle%20eastern%20dessert%20layers%20of%20crispy%20golden%20filo%20phyllo%20pastry%20sheets%20filled%20with%20crushed%20green%20pistachios%20walnuts%20soaked%20in%20sweet%20honey%20syrup%20diamond%20shaped%20pieces%20stacked%20showing%20multiple%20layers%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography&width=400&height=300&seq=baklava003&orientation=landscape',
      category: 'Desserts'
    },
    {
      id: 25,
      name: 'Knafeh',
      description: 'Traditional cheese pastry with crispy kadaif and orange blossom syrup',
      image: 'https://readdy.ai/api/search-image?query=authentic%20knafeh%20kunafa%20traditional%20cheese%20pastry%20with%20crispy%20shredded%20kadaif%20noodles%20orange%20blossom%20syrup%20golden%20orange%20color%20crushed%20pistachios%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20dessert&width=400&height=300&seq=knafeh002&orientation=landscape',
      category: 'Desserts'
    },
    {
      id: 26,
      name: 'Maamoul',
      description: 'Shortbread cookies filled with dates, pistachios, or walnuts',
      image: 'https://readdy.ai/api/search-image?query=authentic%20maamoul%20traditional%20shortbread%20cookies%20filled%20with%20dates%20pistachios%20walnuts%20decorative%20pattern%20on%20top%20powdered%20sugar%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20dessert&width=400&height=300&seq=maamoul002&orientation=landscape',
      category: 'Desserts'
    },
    {
      id: 27,
      name: 'Halawet El Jibn',
      description: 'Sweet cheese rolls filled with clotted cream and pistachios',
      image: 'https://readdy.ai/api/search-image?query=authentic%20halawet%20el%20jibn%20sweet%20cheese%20rolls%20filled%20with%20clotted%20cream%20ashta%20crushed%20pistachios%20rose%20water%20syrup%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20lebanese%20dessert&width=400&height=300&seq=halawet002&orientation=landscape',
      category: 'Desserts'
    },
    {
      id: 28,
      name: 'Basbousa',
      description: 'Semolina cake soaked in rose water syrup with almonds',
      image: 'https://readdy.ai/api/search-image?query=authentic%20basbousa%20semolina%20cake%20soaked%20in%20rose%20water%20syrup%20with%20whole%20almonds%20on%20top%20golden%20yellow%20diamond%20shaped%20pieces%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20dessert&width=400&height=300&seq=basbousa002&orientation=landscape',
      category: 'Desserts'
    },
    {
      id: 29,
      name: 'Lebanese Rice Pudding',
      description: 'Creamy rice pudding with orange blossom water and cinnamon',
      image: 'https://readdy.ai/api/search-image?query=authentic%20lebanese%20rice%20pudding%20creamy%20white%20with%20orange%20blossom%20water%20cinnamon%20powder%20sprinkled%20on%20top%20in%20white%20bowl%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20dessert&width=400&height=300&seq=ricepudding002&orientation=landscape',
      category: 'Desserts'
    },
    {
      id: 30,
      name: 'Fresh Fruit Platter',
      description: 'Seasonal Mediterranean fruits with mint and honey drizzle',
      image: 'https://readdy.ai/api/search-image?query=fresh%20fruit%20platter%20seasonal%20mediterranean%20fruits%20watermelon%20grapes%20figs%20pomegranate%20oranges%20with%20fresh%20mint%20leaves%20honey%20drizzle%20on%20white%20plate%20simple%20clean%20white%20background%20professional%20food%20photography%20healthy%20dessert&width=400&height=300&seq=fruitplatter002&orientation=landscape',
      category: 'Desserts'
    },
    {
      id: 31,
      name: 'Fresh Mint Lemonade',
      description: 'Homemade lemonade with fresh mint leaves and ice',
      image: 'https://readdy.ai/api/search-image?query=fresh%20mint%20lemonade%20homemade%20in%20clear%20glass%20with%20fresh%20mint%20leaves%20lemon%20slices%20ice%20cubes%20condensation%20on%20glass%20simple%20clean%20white%20background%20professional%20food%20photography%20refreshing%20beverage&width=400&height=300&seq=lemonade002&orientation=landscape',
      category: 'Beverages'
    },
    {
      id: 32,
      name: 'Ayran',
      description: 'Traditional yogurt drink with salt and mint',
      image: 'https://readdy.ai/api/search-image?query=authentic%20ayran%20traditional%20yogurt%20drink%20white%20creamy%20with%20salt%20mint%20leaves%20in%20clear%20glass%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20beverage&width=400&height=300&seq=ayran002&orientation=landscape',
      category: 'Beverages'
    },
    {
      id: 33,
      name: 'Jallab',
      description: 'Date molasses drink with rose water, pine nuts, and raisins',
      image: 'https://readdy.ai/api/search-image?query=authentic%20jallab%20date%20molasses%20drink%20dark%20brown%20with%20rose%20water%20topped%20with%20pine%20nuts%20raisins%20ice%20in%20clear%20glass%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20beverage&width=400&height=300&seq=jallab002&orientation=landscape',
      category: 'Beverages'
    },
    {
      id: 34,
      name: 'Turkish Coffee',
      description: 'Strong aromatic coffee prepared in traditional style',
      image: 'https://readdy.ai/api/search-image?query=authentic%20turkish%20coffee%20strong%20aromatic%20in%20traditional%20small%20demitasse%20cup%20with%20foam%20on%20top%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20beverage&width=400&height=300&seq=turkishcoffee002&orientation=landscape',
      category: 'Beverages'
    },
    {
      id: 35,
      name: 'Mint Tea',
      description: 'Fresh mint leaves steeped in hot water with optional honey',
      image: 'https://readdy.ai/api/search-image?query=authentic%20mint%20tea%20fresh%20mint%20leaves%20steeped%20in%20hot%20water%20in%20clear%20glass%20teacup%20simple%20clean%20white%20background%20professional%20food%20photography%20middle%20eastern%20beverage&width=400&height=300&seq=minttea002&orientation=landscape',
      category: 'Beverages'
    },
    {
      id: 36,
      name: 'Fresh Juice Selection',
      description: 'Orange, pomegranate, carrot, or mixed fruit juices',
      image: 'https://readdy.ai/api/search-image?query=fresh%20juice%20selection%20orange%20juice%20pomegranate%20juice%20carrot%20juice%20in%20clear%20glasses%20colorful%20vibrant%20simple%20clean%20white%20background%20professional%20food%20photography%20healthy%20beverage&width=400&height=300&seq=freshjuice002&orientation=landscape',
      category: 'Beverages'
    }
  ];

  return (
    <section id="menu" className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <p className="text-[#C9A961] text-xs sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] uppercase font-light mb-3 sm:mb-4">
            Signature Creations
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-gray-900 font-bold mb-4 sm:mb-6 px-4">
            Exquisite Menu Selection
          </h2>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg font-light max-w-2xl mx-auto leading-relaxed px-4">
            Discover a curated selection of Mediterranean and Middle Eastern specialties, crafted with premium ingredients and decades of culinary expertise.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative h-48 sm:h-56 md:h-64 w-full overflow-hidden bg-gray-100">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-3 sm:top-4 left-3 sm:left-4">
                  <span className="px-3 sm:px-4 py-1 sm:py-1.5 bg-[#C9A961] text-white text-xs sm:text-sm font-light rounded-full">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="font-serif text-xl sm:text-2xl text-gray-900 font-bold mb-2 sm:mb-3">
                  {item.name}
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm font-light leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 sm:mt-12 lg:mt-16 px-4">
          <p className="text-gray-600 text-sm sm:text-base font-light mb-4 sm:mb-6">
            Every dish is customizable to your preferences and dietary requirements
          </p>
          <a
            href="#contact"
            className="inline-block w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-[#C9A961] text-white rounded-lg text-sm sm:text-base font-medium tracking-wide transition-all hover:bg-[#B89851] hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            Request Custom Menu
          </a>
        </div>
      </div>
    </section>
  );
}
